const ResourceTitle = ({ title, subtitle }) => {
  return (
    <>
      <div className={'resource-title'}>
        <div className={'inner-container'}>
          <div className={'title'}>{title}</div>
          <div
            dangerouslySetInnerHTML={{ __html: subtitle }}
            className={'subtitle'}
          />
          {/* <div className={'green-circle'}></div> */}
        </div>
      </div>
    </>
  );
};

export default ResourceTitle;
